export const sortNameConstant: {
  relevance: string;
  highToLow: string;
  lowToHigh: string;
} = {
  relevance: "Relevance",
  highToLow: "Price High to Low",
  lowToHigh: "Price Low to High",
};
